import React from 'react';
import { LocationOn } from '@mui/icons-material';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';

interface AddressInfo {
  city: string | null;
  address: string | null;
  country: string | null;
  postalCode: string | null;
  stateProvince: string | null;
}

interface Props {
  contactAddress: AddressInfo | null;
  deliveryAddress: AddressInfo | null;
}

const formatAddress = (address: AddressInfo | null | undefined) => {
  if (!address) return null;

  return (
    [address.address, address.city, address.stateProvince, address.postalCode, address.country]
      .filter(Boolean)
      .join(', ') || null
  );
};

export const ContactAddressTooltip = ({ contactAddress, deliveryAddress }: Props) => {
  const formattedContact = formatAddress(contactAddress);
  const formattedDelivery = formatAddress(deliveryAddress);

  const tooltipContent = (
    <Stack spacing={0.5}>
      {formattedContact && (
        <Stack>
          <Typography variant="caption" fontWeight={600}>
            Contact Address
          </Typography>

          <Typography variant="caption">{formattedContact}</Typography>
        </Stack>
      )}

      {formattedDelivery && (
        <Stack>
          <Typography variant="caption" fontWeight={600}>
            Delivery Address
          </Typography>

          <Typography variant="caption">{formattedDelivery}</Typography>
        </Stack>
      )}

      {!formattedContact && !formattedDelivery && <Typography variant="caption">No address info</Typography>}
    </Stack>
  );

  return (
    <Tooltip title={tooltipContent} arrow placement="top">
      <IconButton size="small">
        <LocationOn color="info" />
      </IconButton>
    </Tooltip>
  );
};
